import { useMemo } from 'react';
import { Platform, useWindowDimensions } from 'react-native';
import { WEB_SIDEBAR_BREAKPOINT } from '../../../shared/layout/breakpoints';
import { useSessionStore } from '../store/useSessionStore';
import { resolveBarcodeInputFlags } from '../barcodeInputMode';

export type { ResolveBarcodeInputFlagsOptions } from '../barcodeInputMode';
export { resolveBarcodeInputFlags } from '../barcodeInputMode';

export function useBranchBarcodeInputModeForCurrentBranch() {
  const currentBranchId = useSessionStore((s) => s.currentBranchId);
  const branches = useSessionStore((s) => s.branches);
  const { width } = useWindowDimensions();
  const desktopShell = Platform.OS === 'web' && width >= WEB_SIDEBAR_BREAKPOINT;

  return useMemo(() => {
    const b = branches.find((x) => x.id === currentBranchId);
    return resolveBarcodeInputFlags(b?.barcodeInputMode, { desktopShell });
  }, [branches, currentBranchId, desktopShell]);
}
